<template>
  <div class="Menumanagement">
    <div class="Menumanagement_left" v-if="filtering('menu:view')">
      <div>
        <el-input style="margin-top: 10px; width: 300px" suffix-icon="el-icon-search" placeholder="输入搜索" v-model="filterText">
        </el-input>
        <el-tree class="filter-tree" style="margin-top: 10px" :data="Manydata" :props="defaultProps" :filter-node-method="filterNode" @node-click="handleNodeClick" @check-change="handleCheckChange" node-key="id"
          highlight-current show-checkbox ref="tree">
          <span class="custom-tree-node" slot-scope="{scope,data}">
             <span v-if="data.title!=='dms系统'&&data.title!=='柚子客户'&&data.title!=='柚子门店'&&data.title!=='力当家'&&data.title!=='力当家客户'&&data.title!=='雾以希'">{{ data.title }}</span>
                <el-tag v-else  effect="dark" size="mini">{{ data.title }}</el-tag>

          </span>
        </el-tree>
      </div>
      <div>
        <el-button type="primary" style="margin-top: 12px; margin-left: 20px" size="medium " icon="el-icon-refresh-right" @click="Refresh()"></el-button>
        <el-button :disabled="menuIds.length == 0" type="danger" style="margin-top: 12px; margin-left: 10px" size="medium " icon="el-icon-delete" v-if="filtering('menu:delete')" @click="deletes()">
        </el-button>
      </div>
    </div>
    <div class="Menumanagement_right" v-if="filtering('menu:view')">
      <div class="right_title">新增</div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="上级菜单" :disabled="ruleForm.Superiormenu!=null" prop="Superiormenu">
          <el-cascader style="width: 500px" v-model="ruleForm.Superiormenu" :options="Manydata" :props="cascaderProps" @change="adercode" filterable :show-all-levels="false" clearable></el-cascader>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="ruleForm.name"  @input="change($event)" style="width: 500px" placeholder="请输入名称" ></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-radio-group style="width: 500px" v-model="ruleForm.type" @change="getlatype">
            <el-radio style="width: 40px" :disabled="Addedit == '1'" label="0">菜单</el-radio>
            <el-radio style="width: 40px" :disabled="Addedit == '1'" label="1">按钮</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-show="ruleForm.type == '0'">
          <el-form-item label="URL" prop="route">
            <el-input v-model="ruleForm.route" @input="change($event)" style="width: 500px" placeholder="请输入名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="icon" prop="icon">
            <el-input v-model="ruleForm.icon" style="width: 500px" placeholder="请输入名称" @focus="geticon" clearable></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input v-model="ruleForm.sort" style="width: 500px" placeholder="请输入排序" clearable></el-input>
          </el-form-item>
        </div>
        <el-form-item label="权限" prop="jurisdiction">
          <el-input v-model="ruleForm.jurisdiction" style="width: 500px" placeholder="请输入权限" clearable></el-input>
        </el-form-item>
        <el-form-item label="系统用户类型" prop="systemType">
          <el-select
                  @change="handleSystemType"
                  style="width: 500px"
                  v-model="ruleForm.systemType"
                  placeholder="请选择角色分类"
                  clearable
          >
            <el-option :value="1" label="dms后台"></el-option>
            <el-option :value="2" label="柚子客户"></el-option>
            <el-option :value="3" label="柚子门店"></el-option>
            <el-option :value="4" label="力当家"></el-option>
            <el-option :value="5" label="力当家客户"></el-option>
            <el-option :value="6" label="雾以希"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="desc">
          <el-input style="width: 500px" type="textarea" v-model="ruleForm.desc" placeholder="请输入备注" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="newlyadded()" v-if="Addedit == 0&&filtering('menu:add')">新增</el-button>
          <el-button type="primary" @click="newlyadded()" v-if="Addedit == 1&&filtering('menu:update')">修改</el-button>

        </el-form-item>
      </el-form>
    </div>
    <el-dialog title="icon选择" :visible.sync="dialogVisible" width="80%">
      <div class="iconchose">
        <div class="iconchose-son" v-for="(item, index) in iconlist" :key="index" @click="onlinyyou(item)">
          <!-- <feather-icon :icon="item.icon"></feather-icon> -->
          <i :class="item.icon" style="font-size:25px;"></i>
          <div>{{ item.icon }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { OrderApi } from "@/modules/accounts/getapi";
import { iconlist } from "../iconlist.ts";
export default {
  name: "Menumanagement",

  data () {
    return {
      Manydata: [
        {
          title:'dms系统',
          id:1,
          childs:[]
        },
        {
          title:'柚子客户',
          id:2,
          childs:[]
        },
        {
          title:'柚子门店',
          id:3,
          childs:[]
        },
        {
          title:'力当家',
          id:4,
          childs:[]
        },
        {
          title:'力当家客户',
          id:5,
          childs:[]
        },
        {
          title:'雾以希',
          id:6,
          childs:[]
        }
      ],
      filterText: "",
      defaultProps: {
        children: "childs",
        label: "title",
        checkStrictly: true,
      },
      cascaderProps: {
        children: "childs",
        label: "title",
        value: "id",
        checkStrictly: true,
      },
      menuIds: [],
      ruleForm: {
        Superiormenu: "",
        name: "",
        type: "0",
        route: "",
        sort: "",
        jurisdiction: "",
        desc: "",
        icon: "",
        menuId: "",
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      parentId: "",
      Addedit: "0", //0新增 1编辑
      dialogVisible: false,
      iconlist: iconlist,
    };
  },
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val);
    },
  },
  created () {
    this.organization();
  },

  mounted () { },
  methods: {
    change(e){
      this.$forceUpdate()
    },
    handleSystemType(e){
      console.log(e);
      this.ruleForm.systemType = e;
    },
    //点击选择图标
    onlinyyou (e) {
      console.log(e);
      this.ruleForm.icon = e.icon;
      this.dialogVisible = false;
    },
    //图标选择弹窗
    geticon () {
      console.log(123);
      this.dialogVisible = true;
    },
    //切换类型
    getlatype () {
      this.ruleForm.icon = "";
      this.ruleForm.route = "";
      this.ruleForm.sort = "";
    },
    //选择上级菜单
    adercode (e) {
      let list = JSON.parse(JSON.stringify(e));
      this.parentId = list.pop();
    },
    //新增
    newlyadded () {
      var that = this;
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          let data = {
            menuName: this.ruleForm.name,
            menuId: this.ruleForm.menuId, //
            parentId: this.parentId>5?this.parentId:'', //上级菜单
            type: this.ruleForm.type,
            icon: this.ruleForm.icon,
            url: this.ruleForm.route, //url
            perms: this.ruleForm.jurisdiction, //权限
            orderNum: this.ruleForm.sort, //排序
            remarks: this.ruleForm.desc, //备注
            systemType: this.ruleForm.systemType, //系统用户类型
          };
          console.log(data);
          if (that.Addedit == "0") {
            //新增
            that.addmuenstr(data);
          } else {
            //编辑
            that.Editmuenstr(data);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //新增菜单
    async addmuenstr (data) {
      let res = await OrderApi.addmuenstr(data);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "成功!",
        });
        this.Refresh();
      } else if (res.code == 403) {
        console;
      } else {
        this.$message({
          type: "error",
          message: res.message,
        });
      }
    },
    //编辑菜单
    async Editmuenstr (data) {
      let res = await OrderApi.Editmuenstr(data);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "成功!",
        });
        this.Refresh();
      } else if (res.code == 403) {
        console;
      } else {
        this.$message({
          type: "error",
          message: res.message,
        });
      }
    },
    //刷新
    Refresh () {
      this.Manydata = [];
      this.$refs.tree.getCheckedKeys([]);
      this.Addedit = "0";
      this.filterText = "";
      this.ruleForm.name = "";
      this.ruleForm.menuId = "";
      this.parentId = "";
      this.ruleForm.type = "0";
      this.ruleForm.icon = "";
      this.ruleForm.route = "";
      this.ruleForm.jurisdiction = "";
      this.ruleForm.sort = "";
      this.ruleForm.desc = "";
      this.ruleForm.Superiormenu = "";
      this.ruleForm.systemType = "";
      this.organization();
    },
    //删除菜单
    async deletes () {
      let data = {
        menuIds: this.menuIds,
      };
      let res = await OrderApi.Deletemenu(data);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "成功!",
        });
        this.organization();
        this.Refresh();
      } else if (res.code == 403) {
        console;
      } else {
        this.$message({
          type: "error",
          message: res.message,
        });
      }
    },
    //点击菜单
    async handleNodeClick (e) {
      // this.deptId=e.id
      this.Addedit = "1"; //0新增 1编辑
      let data = {
        menuId: e.data.menuId,
      };
      let res = await OrderApi.Querymenu(data);
      this.ruleForm = {};
      this.ruleForm.name = res.data[0].menuName;
      this.ruleForm.menuId = res.data[0].menuId;
      this.parentId = res.data[0].parentId;
      this.ruleForm.type = res.data[0].type;
      this.ruleForm.icon = res.data[0].icon;
      this.ruleForm.route = res.data[0].url;
      this.ruleForm.jurisdiction = res.data[0].perms;
      this.ruleForm.sort = res.data[0].orderNum;
      this.ruleForm.desc = res.data[0].remarks;
      this.ruleForm.Superiormenu = res.data[0].PARENTIDS;
      this.ruleForm.systemType = res.data[0].systemType;
      console.log(this.ruleForm.systemType);
      console.log(e);
    },
    //选中菜单复选框
    handleCheckChange (e) {
      //this.deptId=e.id
      this.menuIds = this.$refs.tree.getCheckedKeys();
    },
    //筛选菜单列表
    filterNode (value, data) {
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
    },
    //获取组织机构
    async organization () {
      this.Manydata = [
        {
          title:'dms系统',
          id:1,
          childs:[]
        },
        {
          title:'柚子客户',
          id:2,
          childs:[]
        },
        {
          title:'柚子门店',
          id:3,
          childs:[]
        },
        {
          title:'力当家',
          id:4,
          childs:[]
        },
        {
          title:'力当家客户',
          id:5,
          childs:[]
        },
        {
          title:'雾以希',
          id:6,
          childs:[]
        }
      ];
      let res = await OrderApi.Permission({});
      res.data.forEach(item=>{
        if(item.data.systemType === 1){
          this.Manydata[0].childs.push(item);
        }
        if(item.data.systemType === 2){
          this.Manydata[1].childs.push(item);
        }
        if(item.data.systemType === 3){
          this.Manydata[2].childs.push(item);
        }
        if(item.data.systemType === 4){
          this.Manydata[3].childs.push(item);
        }
        if(item.data.systemType === 5){
          this.Manydata[4].childs.push(item);
        }
        if(item.data.systemType === 6){
          this.Manydata[5].childs.push(item);
        }
      })
      // this.Manydata.map((item) => {
      //   if (item.childs.length == 0) {
      //     item.childs = null;
      //   } else {
      //     item.childs.map((indes) => {
      //       if (indes.childs.length == 0) {
      //         indes.childs = null;
      //       }
      //     });
      //   }
      // });
      this.$forceUpdate()
      console.log(this.Manydata);
    },
  },
};
</script>

<style lang="scss" scoped>
  .Menumanagement {
    width: 100%;
    display: flex;
    flex-direction: row;
  }
  .Menumanagement_left {
    min-width: 500px;
    height: 100%;
    background: #fff;
    border-radius: 4px;
    padding: 15px;
    display: flex;
    .filter-tree {
      margin-top: 20px;
      width: 300px;
    }
  }
  .Menumanagement_right {
    flex: 1;
    overflow-x: auto;
    background: #fff;
    margin-left: 20px;
    padding: 15px;
    height: 100%;
    border-radius: 4px;
    .right_title {
      font-size: 16px;
      width: 100%;
      height: 50px;
      line-height: 50px;
    }
  }
  .iconchose {
    width: 100%;
    height: 500px;
    overflow: auto;
    .iconchose-son {
      width: 100px;
      height: 75px;

      float: left;
      background: #fff;
      text-align: center;
      line-height: 50px;
      margin-right: 20px;
      border: 1px solid #f5f5f5;
      cursor: pointer;
      margin-top: 20px;
      & > div {
        width: 90%;
        margin: -8px auto;
        height: 20px;
        line-height: 20px;
        overflow: hidden; /*超出部分隐藏*/
        white-space: nowrap; /*不换行*/
        text-overflow: ellipsis; /*超出部分文字以...显示*/
      }
    }
  }
</style>
